import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "conteudo-principal"
}
const _hoisted_2 = { class: "row header" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = {
  key: 0,
  class: "col-md-auto show-on-desktop show-on-sidebar"
}
const _hoisted_5 = { class: "col main main-content" }
const _hoisted_6 = {
  key: 1,
  class: "conteudo-principal"
}
const _hoisted_7 = { class: "row" }
const _hoisted_8 = { class: "col main main-content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Navbar = _resolveComponent("Navbar")!
  const _component_Sidebar = _resolveComponent("Sidebar")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!$setup.apresentarTelaLimpa)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_Navbar)
          ]),
          _createElementVNode("div", _hoisted_3, [
            (!$setup.withIsMobile)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _createVNode(_component_Sidebar)
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_5, [
              _createVNode(_component_router_view)
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    ($setup.apresentarTelaLimpa)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createVNode(_component_router_view)
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}